import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const participantValidationSchema = Yup.object().shape({
  name: Yup.string().required(requiredField),
  jobTitle: Yup.string().required(requiredField),
  email: Yup.string().email().required(requiredField),
  department: Yup.string().required(requiredField),
  // username: Yup.string().required(requiredField),
});
